// eslint-disable-next-line import/prefer-default-export
export const START_STATION = 'start';
